import { Button } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  RequestForInvoicingStatusEnum,
  useCreateRequestForInvoicingMutation,
  useUpdateRequestForInvoicingMutation,
} from "@src/__generated__/graphql";
import { routeHistory } from "@src/helpers/route-history";
import { onError } from "@src/utils/apollo";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useInvoiceStore } from "../../store";

export const SaveAsDraftButton = observer(function SaveAsDraftButton() {
  const appStore = useStore();
  const store = useInvoiceStore();
  const router = useRouter();

  const [createMutation, createRequest] = useCreateRequestForInvoicingMutation({
    async onCompleted(data) {
      appStore.UIStore.toast({
        title: t`Draft created`,
        status: "success",
      });

      if (store.isTimeAndMaterialsSelected) {
        await store.timeAndMaterialsStore.saveFiltersAsTemplate(
          data.createRequestForInvoicing.id,
          "rfi",
        );
      }

      router.push(routeHistory.get("/invoices/for-invoicing"));
    },
    ...onError(),
  });

  const [updateMutation, updateRequest] = useUpdateRequestForInvoicingMutation({
    async onCompleted(data) {
      appStore.UIStore.toast({
        title: t`Draft updated`,
        status: "success",
      });

      if (store.isTimeAndMaterialsSelected) {
        await store.timeAndMaterialsStore.saveFiltersAsTemplate(
          data.updateRequestForInvoicing.id,
          "rfi",
          store.timeAndMaterialsStore.filtersTemplate?.id,
        );
      }

      router.push(routeHistory.get("/invoices/for-invoicing"));
    },
    ...onError(),
  });

  store.setInvoiceMutationLoading(
    createRequest.loading || updateRequest.loading,
  );

  const onSaveAsDraft = async () => {
    const { hasError } = await store.validateAllStepsAsDraft();
    if (hasError) return;

    if (store.invoice_id) {
      updateMutation({
        variables: {
          input: store.updateRequestForInvoiceInput(
            RequestForInvoicingStatusEnum.Draft,
          ),
          skip_date_validations: store.skip_date_validations,
        },
      });
    } else {
      createMutation({
        variables: {
          input: store.createRequestForInvoiceInput(
            RequestForInvoicingStatusEnum.Draft,
          ),
          skip_date_validations: store.skip_date_validations,
        },
      });
    }
  };

  return (
    <Button
      px={{ base: "2", md: "4" }}
      isDisabled={!!store.projectOverdue}
      isLoading={
        store.convertAmountFetcher.isLoading.value ||
        store.exchangeRateFetcher.isLoading.value ||
        updateRequest.loading ||
        createRequest.loading
      }
      onClick={onSaveAsDraft}
      variant="outline"
    >
      <Trans>Save as draft</Trans>
    </Button>
  );
});
